import React from 'react';
import { Input, Button } from 'components';
import { Globals, Constants, SocketEvents } from 'utils';
import { connect } from 'react-redux';
import { AuthService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';
import { ProfileIcon, LockIcon, PasswordActive, PasswordInactive } from 'assets/icons';
import { ImageLogin, LogoWhite } from 'assets/img';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Login extends React.Component<Props> {

	state = {
		form: {
			email: '',
			password: ''
		},
		activePassword: false
	}

	componentDidMount() {
		if (this.props.user) {
			this.props.history.replace('/');
		}

		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Iniciar Sesión',
				onBack: null
			}
		});
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (!this.state.form.email) {
			Globals.showError("Debe ingresar el correo electrónico");
			return;
		}
		if (!this.state.form.password) {
			Globals.showError("Debe ingresar la contraseña");
			return;
		}
		const res: any = await AuthService.login(this.state.form);
		await this.props.dispatch({
			type: 'SET_ACCESS_TOKEN',
			payload: res.access_token
		});
		await this.props.dispatch({
			type: 'SET_USER',
			payload: res.user
		});
		switch(res.user?.level_id) {
			case Constants.LEVELS.ADMIN:
				this.props.history.replace("/admin/home");
			break;

			default:
				this.props.history.replace("/profile");
			break;
		}
	}

	change = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		});
	}
	
	render() {
		return (
			<div id="login">
				<div className="container-black">
					<div className="row container-form">
						<div className="col-lg-5">
							<div className="form-align">
								<form onSubmit={ this.submit }>
									<div className="container-logo">
										<img src={ LogoWhite } className="logo" />
									</div>
									<div className="container-input">
										<p className="label">Correo</p>
										<div className="input-group">
											<Input
												placeholder="Correo Electrónico"
												name="email" 
												onChange={ this.change } />
										</div>
										<p className="label">Contraseña</p>
										<div className="input-group">
											<Input
												placeholder="Contraseña"
												type={ this.state.activePassword ? 'text' : 'password' }
												name="password"
												onChange={ this.change } />
											<div className="input-group-prepend password-view" onClick={ () => {
												this.setState({
													activePassword: !this.state.activePassword
												});
											} }>
												<img src={ this.state.activePassword ? PasswordActive : PasswordInactive } />
											</div>
										</div>
										<div className="text-center">
											<Button type="submit">
												Iniciar Sesión
											</Button>
										</div>
										<div className="row">
											<div className="col-md-12 text-center">
												<div className="recover">
													<Link to="/recover">
														Recuperar contraseña
													</Link>
												</div>	
											</div>
										</div>
									</div>			
								</form>
							</div>
						</div>
						<div className="col-lg-7" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							<img src={ ImageLogin } className="image-login" />
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Login);